import {
  followMember as publicFollowMember,
  unfollowMember as publicUnfollowMember,
  listCurrentMemberFollowing as publicListCurrentMemberFollowing,
  listMemberFollowing as publicListMemberFollowing,
  listCurrentMemberFollowers as publicListCurrentMemberFollowers,
  listMemberFollowers as publicListMemberFollowers,
  queryCurrentMemberConnections as publicQueryCurrentMemberConnections,
  queryMemberConnections as publicQueryMemberConnections,
} from './members-v3-follow-member-followers.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onFollowMemberFollowed as publicOnFollowMemberFollowed } from './members-v3-follow-member-followers.public.js';
import { onFollowMemberUnfollowed as publicOnFollowMemberUnfollowed } from './members-v3-follow-member-followers.public.js';

export const followMember: MaybeContext<
  BuildRESTFunction<typeof publicFollowMember> & typeof publicFollowMember
> = /*#__PURE__*/ createRESTModule(publicFollowMember);
export const unfollowMember: MaybeContext<
  BuildRESTFunction<typeof publicUnfollowMember> & typeof publicUnfollowMember
> = /*#__PURE__*/ createRESTModule(publicUnfollowMember);
export const listCurrentMemberFollowing: MaybeContext<
  BuildRESTFunction<typeof publicListCurrentMemberFollowing> &
    typeof publicListCurrentMemberFollowing
> = /*#__PURE__*/ createRESTModule(publicListCurrentMemberFollowing);
export const listMemberFollowing: MaybeContext<
  BuildRESTFunction<typeof publicListMemberFollowing> &
    typeof publicListMemberFollowing
> = /*#__PURE__*/ createRESTModule(publicListMemberFollowing);
export const listCurrentMemberFollowers: MaybeContext<
  BuildRESTFunction<typeof publicListCurrentMemberFollowers> &
    typeof publicListCurrentMemberFollowers
> = /*#__PURE__*/ createRESTModule(publicListCurrentMemberFollowers);
export const listMemberFollowers: MaybeContext<
  BuildRESTFunction<typeof publicListMemberFollowers> &
    typeof publicListMemberFollowers
> = /*#__PURE__*/ createRESTModule(publicListMemberFollowers);
export const queryCurrentMemberConnections: MaybeContext<
  BuildRESTFunction<typeof publicQueryCurrentMemberConnections> &
    typeof publicQueryCurrentMemberConnections
> = /*#__PURE__*/ createRESTModule(publicQueryCurrentMemberConnections);
export const queryMemberConnections: MaybeContext<
  BuildRESTFunction<typeof publicQueryMemberConnections> &
    typeof publicQueryMemberConnections
> = /*#__PURE__*/ createRESTModule(publicQueryMemberConnections);
/**
 * Triggered when a member follows another member.
 */
export const onFollowMemberFollowed: BuildEventDefinition<
  typeof publicOnFollowMemberFollowed
> &
  typeof publicOnFollowMemberFollowed = createEventModule(
  publicOnFollowMemberFollowed
);
/**
 * Triggered when a member unfollows another member.
 */
export const onFollowMemberUnfollowed: BuildEventDefinition<
  typeof publicOnFollowMemberUnfollowed
> &
  typeof publicOnFollowMemberUnfollowed = createEventModule(
  publicOnFollowMemberUnfollowed
);

export { WebhookIdentityType } from './members-v3-follow-member-followers.universal.js';
export {
  Follower,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  FollowMemberRequest,
  FollowMemberResponse,
  MemberFollowed,
  UnfollowMemberRequest,
  UnfollowMemberResponse,
  MemberUnfollowed,
  ListMyMemberFollowingRequest,
  CursorPaging,
  ListMyMemberFollowingResponse,
  PagingMetadataV2,
  Cursors,
  ListMemberFollowingRequest,
  ListMemberFollowingResponse,
  ListMyMemberFollowersRequest,
  ListMyMemberFollowersResponse,
  ListMemberFollowersRequest,
  ListMemberFollowersResponse,
  QueryMyMemberConnectionsRequest,
  QueryMyMemberConnectionsResponse,
  ConnectedMembers,
  QueryMemberConnectionsRequest,
  QueryMemberConnectionsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  FollowMemberFollowedEnvelope,
  FollowMemberUnfollowedEnvelope,
  ListCurrentMemberFollowingOptions,
  ListCurrentMemberFollowingResult,
  ListMemberFollowingOptions,
  ListMemberFollowingResult,
  ListCurrentMemberFollowersOptions,
  ListCurrentMemberFollowersResult,
  ListMemberFollowersOptions,
  ListMemberFollowersResult,
} from './members-v3-follow-member-followers.universal.js';
export { WebhookIdentityTypeWithLiterals } from './members-v3-follow-member-followers.universal.js';
